export default "__VITE_ASSET__CSyEJsYN__"